import { artBoardActions } from '@store/reducers/artboard'
import type React from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { OptionalMain } from './OptionalMain'

export const Embed: React.FC = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(artBoardActions.setIsEmbed())
  }, [])

  return <OptionalMain />
}
